/* eslint-disable sort-keys */
export const SIRIUS_DEFAULT_RANGE_KEY = {
  approaching: 35,
  meeting: 54,
  mastering: 73
};

/**
 * 2024-25 Sirius custom CMAP cut scores
 * @see https://docs.google.com/spreadsheets/d/1bMzCUif44pfCA7RiqdrXR3o2O48yzlCXNNj-Y7hkWGI/edit?gid=553482847#gid=553482847
 */
export const SIRIUS_REPORT_RANGE_KEY = {
  'Reading Grade 3': {
    approaching: 35,
    meeting: 54,
    mastering: 73
  },
  'Reading Grade 4': {
    approaching: 31,
    meeting: 54,
    mastering: 73
  },
  'Reading Grade 5': {
    approaching: 37,
    meeting: 54,
    mastering: 71
  },
  'Reading Grade 6': {
    approaching: 36,
    meeting: 50,
    mastering: 71
  },
  'Reading Grade 7': {
    approaching: 43,
    meeting: 59,
    mastering: 75
  },
  'Reading Grade 8': {
    approaching: 34,
    meeting: 52,
    mastering: 70
  },
  'Reading English I': {
    approaching: 42,
    meeting: 55,
    mastering: 84
  },
  'Reading English II': {
    approaching: 42,
    meeting: 55,
    mastering: 88
  },
  'Math Grade 3': {
    approaching: 41,
    meeting: 59,
    mastering: 78
  },
  'Math Grade 4': {
    approaching: 40,
    meeting: 58,
    mastering: 78
  },
  'Math Grade 5': {
    approaching: 38,
    meeting: 57,
    mastering: 79
  },
  'Math Grade 6': {
    approaching: 35,
    meeting: 56,
    mastering: 79
  },
  'Math Grade 7': {
    approaching: 43,
    meeting: 59,
    mastering: 83
  },
  'Math Grade 8': {
    approaching: 38,
    meeting: 54,
    mastering: 77
  },
  'Math Algebra I': {
    approaching: 34,
    meeting: 54,
    mastering: 69
  },
  'Math Skills Review': {
    approaching: 66,
    meeting: 77,
    mastering: 88
  },
  'Science Grade 5': {
    approaching: 46,
    meeting: 64,
    mastering: 77
  },
  'Science Grade 8': {
    approaching: 39,
    meeting: 57,
    mastering: 76
  },
  'Science Biology': {
    approaching: 26,
    meeting: 45,
    mastering: 72
  },
  'Social Studies Grade 8': {
    approaching: 43,
    meeting: 61,
    mastering: 73
  },
  'Social Studies U.S. History': {
    approaching: 28,
    meeting: 47,
    mastering: 65
  }
  // 'Writing Grade 4': {
  //   approaching: 56,
  //   meeting: 71,
  //   mastering: 83
  // },
  // 'Writing Grade 7': {
  //   approaching: 57,
  //   meeting: 71,
  //   mastering: 84
  // }
};
